<template>
  <div class="row" style="width: 100%; padding-top: 5%">
    <div class="col-md-12" style="text-align: left">
      <h2>{{ publicacao.titulo }}</h2>
    </div>

    <div class="col-md-12">
      <div class="card" style="width: 100%">
        <!-- /.card-header -->
        <div class="card-body">
          <div style="padding-left: 30px; padding-right: 50px" v-html="publicacao.conteudo"></div>
        </div>
        <!-- /.card-body -->
      </div>
      <!-- /.card -->
    </div>

    <div class="col-md-12">
      <div class="card p-5" style="padding-top: 10px !important; width: 100%; background-color: #ffffba">
        <span>
          <b>Edital publicado pela rede mundial de computadores em sítio designado pelo Juízo.</b>
        </span>
        <span>
          <b>Data da publicação:</b>
          &nbsp;
          <span>{{ formatDate(publicacao.created_at) }}</span>
        </span>
        <span>
          <b>Link publicação:</b>
          <a :href="url_publicacao" style="margin-left: 5px">{{ url_publicacao }}</a>
        </span>
        <span>
          <b>Leilão relacionado:</b>
          <a :href="url_leilao" style="margin-left: 5px">{{ url_leilao }}</a>
          <a class="btn btn-info btn-sm" :href="url_leilao" style="margin-left: 15px">Ir para o leilão</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import wppController from "../controller/wppController";
import sweetAlert from "../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import currencyController from "../controller/currencyController";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import useVueLidate from "@vuelidate/core";
import { computed, reactive } from "vue";
import { helpers } from "@vuelidate/validators";

export default {
  mixins: [wppController, sweetAlert, Swal, currencyController],

  props: ["publicacao", "leilao", "edital"],

  components: { Loading },

  setup() {
    const formData = reactive({
      termos: false,
    });

    const rules = computed(() => {
      return {
        termos: { aceitarTermos: helpers.withMessage(" Você precisa aceitar os termos de uso", aceitarTermos) },
      };
    });

    const aceitarTermos = (value) => {
      return value;
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  data() {
    return {
      container: {},
      nome: "",
      email: "",
      senha: "",
      tipo_usuario: "",
      isLoading: false,
      foto_selecionada: "",
      indice_atual: 0,
      documentos: [],
      venda_direta: false,
      isLoading: false,
      show_contato: false,
      show_habilitacao: false,
      show_auditorio_btn: false,
      show_auditorio_btn: false,
      url_publicacao: "",
      url_leilao: "",
    };
  },

  mounted() {
    console.log("Detalhes");
    console.log(this.lote);
    console.log(this.leilao);

    this.url_publicacao = process.env.MIX_VUE_APP_URL + "/" + this.edital.id+"/publicacao";
    this.url_leilao = process.env.MIX_VUE_APP_URL + "/leilao/" + this.leilao.id+"/lotes";

    if (this.user) {
      if (!this.habilitacao) {
        this.show_habilitacao = true;
      } else if (this.habilitacao.status != "liberado") {
        this.show_habilitacao = true;
      } else if (this.habilitacao.status == "liberado") {
        this.show_auditorio_btn = true;
      }
    }

    if (this.fotos && this.fotos.length) {
      this.foto_selecionada = this.fotos[0];
    }

    this.venda_direta = this.leilao.leilao_1_modalidade == "venda";

    //DOCUMENTOS DO LEILÃO
    for (let i = 0; i < this.lote.documentos.length; i++) {
      this.documentos.push(this.lote.documentos[i]);
    }

    //DOCUMENTOS DO LOTE
    for (let i = 0; i < this.leilao.documentos.length; i++) {
      let indice = this.findDoc(this.leilao.documentos[i].id);

      if (indice < 0) {
        this.documentos.push(this.leilao.documentos[i]);
      }
    }

    //ALFABÉTICO
    this.documentos.sort(function (a, b) {
      if (a.nome < b.nome) {
        return -1;
      }
      if (a.nome > b.nome) {
        return 1;
      }
      return 0;
    });

    //ORDEM
    this.documentos.sort((a, b) => a.ordem - b.ordem);
  },

  methods: {
    getEdital() {},

    getPre() {
      return "Leilão " + this.leilao.id + " - Lote " + this.lote.id;
    },

    checkHabilitacao() {
      this.show_contato = false;

      this.isLoading = true;

      let data = {
        leilao_id: this.leilao.id,
      };

      console.log("Busca");
      console.log(data);

      axios
        .post(`/user/habilitacao/check`, data)
        .then((response) => {
          console.log(response.data);

          this.isLoading = false;

          if (response.data.success) {
            document.getElementById("cancelar").click();
          } else {
            this.showErrorMessageWithButtonAndRedirect("Ops...", response.data.msg, "/lote/" + this.lote.id);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    checkIsHabilitado() {
      this.show_contato = false;

      this.isLoading = true;

      let data = {
        leilao_id: habilitacao.leilao,
      };

      console.log("Busca");
      console.log(data);

      axios
        .post(`/user/habilitacao/check`, data)
        .then((response) => {
          console.log(response.data);

          this.isLoading = false;

          if (response.data.habilitado) {
            window.location.href = this.getUrlAuditorio(habilitacao.leilao);
          } else {
            this.showErrorMessageWithButtonAndRedirect("Ops...", "Favor atualizar a tela.", "/user/habilitacoes");
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    findDoc(id) {
      let indice = this.documentos.findIndex((element) => element["id"] == id);

      return indice;
    },

    selecionarFoto(foto, indice_atual) {
      this.indice_atual = indice_atual;
      this.foto_selecionada = foto;
    },

    fotoAnterior(indice_atual) {
      if (indice_atual >= 0) {
        this.indice_atual = indice_atual;
        this.foto_selecionada = this.fotos[indice_atual];
      }
    },

    proximaFoto(indice_atual) {
      if (indice_atual < this.fotos.length) {
        this.indice_atual = indice_atual;
        this.foto_selecionada = this.fotos[indice_atual];
      }
    },

    getLink(documento) {
      return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + documento.path + "/" + documento.file;
    },

    getImagePath() {
      return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + this.leilao.path + "/" + this.leilao.arquivo;
    },

    getImageFoto(foto) {
      return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + foto.path + "/" + foto.img;
    },

    async validateFields() {
      const result = await this.v$.$validate();

      if (result) {
        this.pedirHabilitacao();
      } else {
        console.log(this.v$);
      }
    },

    pedirHabilitacao() {
      this.isLoading = true;

      let data = {
        leilao_id: this.leilao.id,
      };

      console.log("Busca");
      console.log(data);

      axios
        .post(`/user/habilitacao/pedir`, data)
        .then((response) => {
          console.log("Retorno habilitação");
          console.log(response.data);

          this.isLoading = false;

          if (response.data.success) {
            this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Habilitação solicitada!", "/lote/" + this.lote.id);
          } else {
            this.showErrorMessageWithButtonAndRedirect("Ops...", response.data.msg, "/lote/" + this.lote.id);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm:ss");
    },

    validateEmail() {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        return true;
      } else {
        return false;
      }
    },

    generateKey() {
      return Math.random().toString(36).slice(2);
    },
  },
};
</script>

<style scoped>
.img-t {
  transition-duration: 500ms;
  transform: scale(1.4);
}

.ic:hover {
  transition-duration: 500ms;
  transform: scale(1.4);
  color: #696969;
}

.im {
  width: 1500px;
}

.swal-modal {
  color: green;
  background-color: rgba(63, 255, 106, 0.69);
  border: 3px solid white;
}

.swal-overlay {
  background-color: rgba(43, 165, 137, 0.45);
}

.modal-content {
  margin-top: 20%;
  width: 600px;
  margin-left: -20px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 600px;
    margin-left: -20px;
    margin-top: 100px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 600px;
    margin-left: -20px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}

.realizado {
  text-decoration: line-through;
}
</style>
